module.exports = __webpack_public_path__ + "img/lift-panel-exit.77c92fbd.jpg";